var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:[_vm.type, _vm.addedClass, {hide: _vm.hide}, {'has-delay': _vm.hasDelay}],style:([
    _vm.top != null ?
      {top: _vm.top + 'px', opacity: 1}
    : ''
  ])},[_c('img',{attrs:{"src":_vm.image,"data-1x":_vm.image,"data-2x":_vm.image2x,"alt":_vm.altText,"height":"25","width":"25","draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }